import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import {
  Breadcrumbs,
  Link,
  TextField,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveSharpIcon from "@mui/icons-material/SaveSharp";
import CancelIcon from "@mui/icons-material/Cancel";
import Swal from "sweetalert2";
import "../AreaPriceDetails/AreaPriceDetails.css";
import { Tooltip } from "@mui/material";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import { IconButton } from "@mui/material";
import { ClipLoader } from "react-spinners";

const AreaList = () => {
  const [areas, setAreas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(5);
  const [editRow, setEditRow] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [groupNames, setGroupNames] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [originalAreas, setOriginalAreas] = useState([]);
  const [sortOrderMinAmount, setSortOrderMinAmount] = useState("");
  const [sortOrderThirtyAmount, setSortOrderThirtyAmount] = useState("");
  const [sortOrderFullAmount, setSortOrderFullAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const dropdownAreasList = [
    "Acres",
    "5 Guntas",
    "10 Guntas",
    "150 Square Yards",
    "200 Square Yards",
  ];

  const dropdownGroupNames = ["FUTURE_GREEN_CITY", "SAI_KESHAVA"];

  useEffect(() => {
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    try {
      const token = localStorage.getItem("authToken");
      console.log("🔹 Retrieved Token:", token);

      if (!token || token === "null" || token === "undefined") {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "You are not authenticated. Please log in.",
        });
        return;
      }

      const response = await fetch(`${ADMIN_API_BASE_URL}/main/admin/areas`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error("API Error:", response.status, response.statusText);
        Swal.fire({
          icon: "error",
          title: "API Error",
          text: `Error ${response.status}: ${response.statusText}`,
        });
        return;
      }

      const data = await response.json();
      console.log("Parsed data:", data);

      if (Array.isArray(data)) {
        setAreas(data);
        setOriginalAreas(data);
        const groups = [...new Set(data.map((area) => area.groupName))];
        setGroupNames(groups);
      } else {
        console.error("Expected an array but got:", data);
        setAreas([]);
      }
    } catch (error) {
      console.error("Error fetching areas:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while fetching areas.",
      });
    } finally {
      setLoading(false);
    }
  };

  // const filteredAreas = selectedGroup
  //   ? areas.filter((area) => area.groupName === selectedGroup)
  //   : areas;

  const filteredAreas = areas.filter((area) => {
    return (
      (!selectedGroup || area.groupName === selectedGroup) &&
      (!selectedArea || area.area === selectedArea)
    );
  });

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("authToken");

        const response = await fetch(
          `${ADMIN_API_BASE_URL}/main/admin/delete-area/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete area");
        }

        setAreas((prevAreas) => prevAreas.filter((area) => area.id !== id));

        Swal.fire("Deleted!", "Your area has been deleted.", "success");
      } catch (error) {
        console.error("Error deleting area:", error);
        Swal.fire("Error", "Failed to delete area", "error");
      }
    }
  };

  const handleEdit = (area) => {
    setEditRow({ ...area });
    setAreas(
      areas.map((a) => (a.id === area.id ? { ...a, isEditing: true } : a))
    );
  };

  const handleSortByStatus = () => {
    let newSortOrder =
      sortOrder === "" ? "asc" : sortOrder === "asc" ? "desc" : "";
    setSortOrder(newSortOrder);

    if (newSortOrder === "") {
      setAreas([...originalAreas]);
      return;
    }

    const sortedAreas = [...areas].sort((a, b) => {
      if (newSortOrder === "asc")
        return a.active === b.active ? 0 : a.active ? 1 : -1;
      if (newSortOrder === "desc")
        return a.active === b.active ? 0 : a.active ? -1 : 1;
      return 0;
    });

    setAreas(sortedAreas);
  };

  const handleSort = (sortOrder, setSortOrder, field) => {
    let newSortOrder =
      sortOrder === "" ? "asc" : sortOrder === "asc" ? "desc" : "";
    setSortOrder(newSortOrder);

    if (newSortOrder === "") {
      setAreas([...originalAreas]);
      return;
    }

    const sortedAreas = [...areas].sort((a, b) => {
      let valueA = Number(a[field]) || 0;
      let valueB = Number(b[field]) || 0;
      return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
    });

    setAreas(sortedAreas);
  };

  const handleSortByMinAmount = () =>
    handleSort(sortOrderMinAmount, setSortOrderMinAmount, "minimumAmount");
  const handleSortByThirtyAmount = () =>
    handleSort(
      sortOrderThirtyAmount,
      setSortOrderThirtyAmount,
      "thirtyPercentageAmount"
    );
  const handleSortByFullAmount = () =>
    handleSort(sortOrderFullAmount, setSortOrderFullAmount, "fullAmount");

  const handleChange = (field, value) => {
    setEditRow((prevState) => ({ ...prevState, [field]: value }));
  };

  const handleSave = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("authToken");

        const response = await fetch(
          `${ADMIN_API_BASE_URL}/main/admin/update-area/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(editRow),
          }
        );

        console.log("Updating area:", editRow);

        if (!response.ok) {
          throw new Error("Failed to update area");
        }
        await fetchAreas();
        setEditRow(null);
        Swal.fire("Saved!", "Your changes have been saved.", "success");
      } catch (error) {
        console.error("Error updating area:", error);
        Swal.fire("Error", "Failed to update area", "error");
      }
    }
  };

  const handleCancel = (id) => {
    setAreas(
      areas.map((area) =>
        area.id === id ? { ...area, isEditing: false } : area
      )
    );
    setEditRow(null);
  };

  const handleStatusChange = async (id, value) => {

    const updatedStatus = value === "Active";

    try {
      const response = await fetch(
        `${ADMIN_API_BASE_URL}/main/admin/update-area/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ active: updatedStatus }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update status");
      }

      setAreas(
        areas.map((area) =>
          area.id === id ? { ...area, active: updatedStatus } : area
        )
      );
      setEditRow((prevState) => ({
        ...prevState,
        active: value === "Active",
      }));
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const totalPages = Math.ceil(filteredAreas.length / recordsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5 res_container"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "20px",
            }}
          >
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link
                underline="hover"
                key="1"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="none"
                key="2"
                color="inherit"
                href="/admin/area_list"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Area List
              </Link>
            </Breadcrumbs>
          </div>

          <p className="text-center fw-bold main_heading">Area List</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} className="ad_hor_line" />
          </div>

          {/* Search Dropdown for Group Selection */}
          <div className="arealist_cont" style={{ textAlign: "start" }}>
            <div
              className="display_groups"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "90%",
              }}
            >
              <Select
                value={selectedArea}
                onChange={(e) => setSelectedArea(e.target.value)}
                variant="outlined"
                size="small"
                style={{ width: "200px" }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>All Areas</em>
                </MenuItem>
                {dropdownAreasList.map((area, index) => (
                  <MenuItem key={index} value={area}>
                    {area}
                  </MenuItem>
                ))}
              </Select>
              <Select
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
                variant="outlined"
                size="small"
                style={{ width: "200px" }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>All Groups</em>
                </MenuItem>
                {groupNames.map((group, index) => (
                  <MenuItem key={index} value={group}>
                    {group}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          {/* <div className="container admin_table_cont"> */}

          <Table
            className="table ad_area_list_table"
            style={{ margin: "0 auto", width: "90%", marginTop: "15px" }}
          >
            <Thead
              className="text-white"
              style={{ backgroundColor: "darkslategrey" }}
            >
              <Tr>
                <Th>S.No</Th>
                <Th style={{ width: "15%" }}>Area</Th>
                <Th>Group Name</Th>
                <Th
                  onClick={handleSortByMinAmount}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Percentage
                    <Tooltip
                      title={
                        sortOrderMinAmount === ""
                          ? "Default"
                          : sortOrderMinAmount === "asc"
                            ? "Sort Ascending"
                            : "Sort Descending"
                      }
                    >
                      <span style={{ fontSize: "1.2em", marginLeft: "5px" }}>
                        {sortOrderMinAmount === ""
                          ? "⇅"
                          : sortOrderMinAmount === "asc"
                            ? "⬆️"
                            : "⬇️"}
                      </span>
                    </Tooltip>
                  </div>
                </Th>

                <Th
                  onClick={handleSortByThirtyAmount}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Percentage Amount
                    <Tooltip
                      title={
                        sortOrderThirtyAmount === ""
                          ? "Default"
                          : sortOrderThirtyAmount === "asc"
                            ? "Sort Ascending"
                            : "Sort Descending"
                      }
                    >
                      <span style={{ fontSize: "1.2em", marginLeft: "5px" }}>
                        {sortOrderThirtyAmount === ""
                          ? "⇅"
                          : sortOrderThirtyAmount === "asc"
                            ? "⬆️"
                            : "⬇️"}
                      </span>
                    </Tooltip>
                  </div>
                </Th>

                <Th
                  onClick={handleSortByFullAmount}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Full Amount
                    <Tooltip
                      title={
                        sortOrderFullAmount === ""
                          ? "Default"
                          : sortOrderFullAmount === "asc"
                            ? "Sort Ascending"
                            : "Sort Descending"
                      }
                    >
                      <span style={{ fontSize: "1.2em", marginLeft: "5px" }}>
                        {sortOrderFullAmount === ""
                          ? "⇅"
                          : sortOrderFullAmount === "asc"
                            ? "⬆️"
                            : "⬇️"}
                      </span>
                    </Tooltip>
                  </div>
                </Th>

                {/* <Th>Status</Th> */}

                <Th
                  onClick={handleSortByStatus}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <div>
                    Status
                    <Tooltip
                      title={
                        sortOrder === ""
                          ? "Default"
                          : sortOrder === "asc"
                            ? "Sort Ascending"
                            : "Sort Descending"
                      }
                    >
                      <span style={{ fontSize: "1.2em", marginLeft: "10px" }}>
                        {sortOrder === "" ? "⇅" : sortOrder === "asc" ? "⬆️" : "⬇️"}
                      </span>
                    </Tooltip>
                  </div>
                </Th>

                <Th style={{ width: "150px" }}>Action</Th>
              </Tr>
            </Thead>
            {filteredAreas.length > 0 ? (
              <Tbody>
                {filteredAreas
                  .slice(indexOfFirstRecord, indexOfLastRecord)
                  .map((area, index) => (
                    <Tr
                      key={area.id}
                      style={{
                        backgroundColor:
                          area.active === 0 ? "#f8d7da" : "transparent",
                      }}
                    >
                      <Td>{indexOfFirstRecord + index + 1}</Td>
                      <Td>
                        {area.isEditing ? (
                          <Select
                            value={editRow?.area || ""}
                            onChange={(e) => handleChange("area", e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ width: "100%" }}
                          >
                            {dropdownAreasList.map((areaOption, i) => (
                              <MenuItem key={i} value={areaOption}>
                                {areaOption}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          area.area
                        )}
                      </Td>

                      <Td>
                        {area.isEditing ? (
                          <Select
                            value={editRow?.groupName || ""}
                            onChange={(e) =>
                              handleChange("groupName", e.target.value)
                            }
                            variant="outlined"
                            size="small"
                            style={{ width: "100%" }}
                          >
                            {dropdownGroupNames.map((group, index) => (
                              <MenuItem key={index} value={group}>
                                {group}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          area.groupName
                        )}
                      </Td>
                      <Td>
                        {area.isEditing ? (
                          <TextField
                            value={editRow?.minimumAmount || ""}
                            onChange={(e) =>
                              handleChange("minimumAmount", e.target.value)
                            }
                            variant="outlined"
                            size="small"
                          />
                        ) : (
                          area.percentage
                        )}
                      </Td>
                      <Td>
                        {area.isEditing ? (
                          <TextField
                            value={editRow?.thirtyPercentageAmount || ""}
                            onChange={(e) =>
                              handleChange("thirtyPercentageAmount", e.target.value)
                            }
                            variant="outlined"
                            size="small"
                          />
                        ) : (
                          area.thirtyPercentageAmount
                        )}
                      </Td>
                      <Td>
                        {area.isEditing ? (
                          <TextField
                            value={editRow?.fullAmount || ""}
                            onChange={(e) =>
                              handleChange("fullAmount", e.target.value)
                            }
                            variant="outlined"
                            size="small"
                          />
                        ) : (
                          area.fullAmount
                        )}
                      </Td>
                      <Td
                        style={{
                          fontWeight: "bold",
                          color: area.active ? "green" : "red",
                        }}
                      >
                        {area.isEditing ? (
                          <Select
                            value={editRow?.active ? "Active" : "Inactive"}
                            onChange={(e) =>
                              handleStatusChange(area.id, e.target.value)
                            }
                            variant="outlined"
                            size="small"
                            style={{ width: "100%" }}
                          >
                            <MenuItem value="Active" style={{ color: "green" }}>
                              Active
                            </MenuItem>
                            <MenuItem value="Inactive" style={{ color: "red" }}>
                              Inactive
                            </MenuItem>
                          </Select>
                        ) : area.active ? (
                          "Active"
                        ) : (
                          "Inactive"
                        )}
                      </Td>

                      <Td className="saveandedit_cont">
                        {area.isEditing ? (
                          <div style={{ display: "flex", gap: "5px" }}>
                            <Tooltip title="Save">
                              <IconButton
                                onClick={() => handleSave(area.id)}
                                className="border-0 text-success"
                              >
                                <SaveSharpIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <IconButton
                                onClick={() => handleCancel(area.id)}
                                className="border-0 "
                                style={{ color: "red" }}
                              >
                                <CancelIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ) : (
                          <div style={{ display: "flex", gap: "5px" }}>
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => handleEdit(area)}
                                className="border-0 text-primary admin_edit_btn"
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => handleDelete(area.id)}
                                className="border-0 "
                                style={{ color: "red" }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            ) : (
              <Tbody>
                <Tr>
                  <Td
                    colSpan="8"
                    style={{
                      textAlign: "center",
                      color: "red",
                      fontWeight: "bold",
                      padding: "20px",
                    }}
                  >
                    No data found
                  </Td>
                </Tr>
              </Tbody>
            )}
          </Table>

          <div
            style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
          >
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i + 1}
                onClick={() => paginate(i + 1)}
                variant={currentPage === i + 1 ? "contained" : "outlined"}
                style={{ margin: "0 5px" }}
              >
                {i + 1}
              </Button>
            ))}
          </div>
        </>
      )}
    </Base>
  );
};

export default AreaList;
